module.exports = __webpack_public_path__ + "media/src/images/abouts/bg_image/p0044_l-49f95a46a075fe5b151133c1750e2299.jpeg";